import { get } from "lodash";
import mediator from "@tvg/mediator";
import { track } from "../../../amplitude";
import { BaseEventProps } from "../../../types";
import {
  MediatorEventType,
  ModuleEventProps,
  EventProps,
  PromoOptInInfo
} from "./types";
import { EVENTS } from "./constants";

export default () => {
  mediator.base.subscribe(
    MediatorEventType.OPT_IN_SUCCESSFUL,
    (data: PromoOptInInfo) => {
      track<EventProps>(EVENTS.OPT_IN_SUCCESSFUL, {
        [ModuleEventProps.PROMO_ID]: get(data, "payload.promoId"),
        [BaseEventProps.PROMO_NAME]: get(data, "payload.promoName"),
        [BaseEventProps.MODULE]: "promo_hub_offer"
      });
    }
  );

  mediator.base.subscribe(
    MediatorEventType.OPT_IN_FAILED,
    (data: PromoOptInInfo) => {
      track<EventProps>(EVENTS.OPT_IN_FAILED, {
        [ModuleEventProps.PROMO_ID]: get(data, "payload.promoId"),
        [BaseEventProps.PROMO_NAME]: get(data, "payload.promoName"),
        [BaseEventProps.MODULE]: "promo_hub_offer"
      });
    }
  );
};
